import { Any, Cookie, Obj, Event, Arr } from "@kizmann/pico-js";
import AppService from "#pub/service/AppService.js";

export default {

    name: 'Application',

    data()
    {
        return {
            load: [],
            init: false,
            login: true,
            status: null,
            tokens: [],
        };
    },

    mounted()
    {
        let auth = Cookie.get('sx-api-auth');

        if ( ! Any.isEmpty(auth) ) {
            return this.runInitCalls();
        }

        this.init = Any.isEmpty(auth);
    },

    methods: {

        runInitCalls()
        {
            Promise.all([this.fetchStatus(), this.fetchTokens()])
                .then(() => {
                    this.init = true;
                    this.login = false;
                })
                .catch(() => {
                    this.init = true;
                    this.login = true;
                });
        },

        fetchStatus()
        {
            let config = {
                onLoad: () => Arr.add(this.load, 'status'),
                onDone: () => Arr.remove(this.load, 'status'),
            };

            return AppService.fetchStatus(config)
                .then((res) => {
                    this.status = Obj.get(res.data, 'data', {});
                });
        },

        fetchTokens()
        {
            let config = {
                onLoad: () => Arr.add(this.load, 'clients'),
                onDone: () => Arr.remove(this.load, 'clients'),
            };

            return AppService.fetchTokens(config)
                .then((res) => {
                    this.tokens = Obj.get(res.data, 'data', []);
                });
        }

    },

    renderIndex()
    {
        return (
            <NLoader class="app-index">
                <div class="app-index__side">
                    <AppLogo />
                    <AppNavigation />
                </div>
                <div class="app-index__body">
                    <RouterView />
                </div>
            </NLoader>
        );
    },

    renderLogin()
    {
        return (
            <AppLogin />
        );
    },

    renderLoad()
    {
        return (
            <div id="app-load">
                <span>{this.trans('Checking login state ...')}</span>
            </div>
        );
    },

    render()
    {
        if ( ! this.init ) {
            return this.ctor('renderLoad')();
        }

        if ( this.login ) {
            return this.ctor('renderLogin')();
        }

        return this.ctor('renderIndex')();
    }
}